import React, { useState } from 'react';
import {Tooltip, Modal, Button, Overlay } from 'react-bootstrap';
import useTextToSpeech from 'src/utils/useTextToSpeech';
import VolumeUp from "../../assets/images/volume-up.svg"
import "./tooltip.css"

export default function TooltipItem(props) {
	const { item, id } = props;
	const [tooltipOpen, setTooltipOpen] = useState(false);
	const [modal, setModal] = useState(false);
	const [showDetails, setShowDetails] = useState(false);
	const [showTooltip, setShowTooltip] = useState(false);
    const targetRef = React.useRef(null);

	const { speak } = useTextToSpeech({
		language: "English",
		preferMaleVoice: true,
	});
	
	const toggle = () => setTooltipOpen(!tooltipOpen);
	const toggleModal = () => setModal(!modal);


	const showDetailsPopup = () => {
		setShowDetails(true);
	}

	const closePopup = () => {
		setShowDetails(false);
	}


	const phonemes = (details) => {
		if (!Array.isArray(details)) return null;
		return (
			<>
				{
					details.map((detail, i) => {
						let className = 'text-success';
						if (detail.decision === 'error') {
							className = 'text-danger';
						
						} else if (detail.decision === 'incorrect') {
							className = detail.nativeness_score > 30 ? 'text-warning' : 'text-danger';
						
						} else if (detail.decision === 'warning') {
							className = 'text-warning';
						
						} else if (detail.decision === 'correct') {
							className = 'text-success';
						
						}

						const text = detail.decision === 'correct' ? 'Excellent' : 'Incorrect';
						const feedback = "feedback" in detail ? detail.feedback : null;
						return (
							<div className="row ati-phoneme-row py-3 mx-0" key={i} style={{ borderBottom: i < details.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
								<div className="col-4 ati-phoneme-ipa " style={{ fontSize: '1.2rem', color: '#666' }}>
									\{'trans' in detail ? detail.trans : detail.ipa}\
								</div>
								<div className="col-8 px-4">
									<div className={`ati-status-text fw-bold ${className}`} style={{ marginBottom: '4px' }}>{text}</div>
									{feedback !== null &&
										<div className="ati-feedback-text text-muted" style={{ lineHeight: '1.4' }}>
											{feedback}
										</div>
									}
								</div>
							</div>
						)
					})
				}
			</>
		);
	}

	const gatheredPhonemes = (details) => {
		if (!Array.isArray(details)) return null;
		return (
			<>
				{
					details.map((detail, i) => {
						let className = 'text-success';
						if (detail.decision === 'error') {
							className = 'text-danger';
						
						} else if (detail.decision === 'incorrect') {
							className = detail.nativeness_score > 30 ? 'text-warning' : 'text-danger';
						
						} else if (detail.decision === 'warning') {
							className = 'text-warning';
						
						} else if (detail.decision === 'correct') {
							className = 'text-success';
						
						}
						
						return (
							<span className={className} key={i}>{'trans' in detail ? detail.trans : detail.ipa}</span>
						)
					})
				}
			</>
		);
	}

	const wordPronunce = (e, word) => {
		// const speech = new Speech();
		speak(word);
	}


	return (
		<>

			{item.class === 'pause-info' ? (
				<span className={`${item.class} tooltip-word`}>
					{item.word !== "&nbsp;" ? item.word : " "}
				</span>
			) : (
				<>
					<span
						ref={targetRef}
						className={`${item.class} tooltip-word`}
						style={{ cursor: 'pointer', display: 'inline-block' }}
						onMouseEnter={() => !showDetails && setShowTooltip(true)}
						onMouseLeave={() => setShowTooltip(false)}
						onClick={showDetailsPopup}
					>
						{item.word !== "&nbsp;" ? item.word : " "}
					</span>

					{item.word !== "&nbsp;" && item.word_score !== undefined && targetRef.current && (
						<Overlay target={targetRef.current} show={showTooltip} placement="top">
							{(props) => (
								<Tooltip {...props} id={`tooltip-${id}`}>
									Word Score <br />
									<b className={item.class}>{parseInt(item.word_score)}</b> / 100
								</Tooltip>
							)}
						</Overlay>
					)}
				</>
			)}

			{item.class != 'pause-info' && 'details' in item &&
				<Modal show={showDetails} size="md" centered onHide={closePopup} style={{zIndex: 9999}} contentClassName="ati-modal-content">
					<Modal.Body className="p-4">
						<div className="d-flex align-items-center justify-content-between mb-4">
							<div className="d-flex align-items-center">
								<div className="ati-header-icon-container">
									<img onClick={(e) => wordPronunce(e, item.word.trim())} src={VolumeUp} alt="Volume Up" style={{ width: '16px' , cursor:"pointer" }} />
								</div>
								<h5 className="ati-header-title mb-0">Word Pronunciation</h5>
							</div>
							<div className="ati-close-btn-round" onClick={closePopup}>
								{/* <span style={{fontWeight:"600"}}>X</span> */}
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 24 24"
									width="24"
									height="24">
									<path
									d="M18 6L6 18M6 6l12 12"
									stroke="currentColor"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
									/>
						  		</svg>
							</div>
						</div>

						<div className="ati-details-container">
							<div className="row ati-phoneme-row py-3 mx-0" style={{ borderBottom: '1px solid #f0f0f0' }}>
								<div className="col-4 px-3 text-start">
									<div className="ati-comparison-word">\{item.word.trim()}\</div>
									<div className="ati-comparison-label">Sound</div>
								</div>
								<div className="col-8 px-4 text-start">
									<div className="ati-comparison-word">\{gatheredPhonemes(item.details)}\</div>
									<div className="ati-comparison-label">You Said</div>
								</div>
							</div>
							{phonemes(item.details)}
						</div>

						<div className="mt-4 pt-2">
							<Button variant="dark" className="ati-main-close-btn" onClick={closePopup}>
								Close
							</Button>
						</div>
					</Modal.Body>
				</Modal>
			}
		</>
	);
}